import { QuotePostRequestBody } from '@lio/api-types';

/**
 * `nonLiveJurisdictionAction` is not yet part of the published `@lio/api-types` package — the
 * backend field is being added in a companion PR (LIO-28733). This local extension lets the
 * frontend compile against it now; once the real field ships in `@lio/api-types` this alias
 * should be removed in favor of the published type.
 */
export type NonLiveJurisdictionAction = 'declineIfInvalid' | 'createInternalOnly';

export type QuotePostRequestBodyWithNonLiveJurisdictionAction = QuotePostRequestBody & {
  nonLiveJurisdictionAction?: NonLiveJurisdictionAction;
};

export enum ProductOfferingId {
  GenericLinesProduct = 'clb5i45q90003ukv54zyd7wou',
  SwimClub = 'clxo6f3xb00050cmoaapk33r6',
  SpecialEvent = 'cm6pxdblu00009jv5c7ev0ul4',
  AmateurSports = 'cljza1h7w0000jov5alt29j7n',
  NonprofitAndSocialServices = 'cloonk7sg00008iv7fe8f3kb4',
  HomeOwnersAssociation = 'cmg9t0iju00014z5u31woesn0',
  CondoOwnersAssociation = 'cmga4g2rc0000l6sfgzoubwln',
}

export const InsuranceProductIds = {
  SwimClub: 'clxo6f3xb00040cmo7jxth3fh',
  SpecialEvents: 'cm6pxcus7000079v5huwggpl1',
  HomeOwnersAssociation: 'cmg9t0iju00004z5u12i246jr',
  CondoOwnersAssociation: 'cmga7fhxy00011ssf5hhd205e',
};
